import { makeStyles } from '@rbx/ui';

const useCodeSamplesStyles = makeStyles()((theme) => ({
  outerContainer: {
    '& > *:first-child': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    '& > *': {
      marginBottom: theme.spacing(22 / 8),
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
}));

export default useCodeSamplesStyles;
